<pr-form
  (onSubmit)="onSubmit()"
  title="Votre portefeuille sur mesure"
  [formGroup]="form"
  clazz="drawer-form"
>
  <div class="pr-form-list-add">
    <pr-button
      [hidden]="!hideTable"
      clazz="btn-list-add neutral"
      rightIcon="sp-plus"
      label="Ajouter un nouveau support"
      (onClick)="openSupportsForm()"
    ></pr-button>
  </div>

  <pr-table-form
    #tableForm
    [hidden]="hideTable"
    [formGroup]="allocation"
    [addButtonLabel]="'Gérez vos supports'"
    variant="ASSET_SUPPORT"
    swiperMinWidth="768"
    (onSelectClick)="openSupportsForm()"
    [columnsDefinition]="columnsDefinition"
    [formatTable]="formatTableDataFunction()"
    [createModelDefinition]="createModel"
    (optionSelected)="newOptionLogic()"
    (noData)="onSupportsChange($event)"
  >
  </pr-table-form>

  <pr-color-panel [display]="allocationPanel.display">
    <pr-panel-body clazz="pam">
      <pr-label [name]="allocationPanel.icon" [width]="18" [height]="18">{{
        allocationPanel.text
      }}</pr-label>
    </pr-panel-body>
  </pr-color-panel>

  <pr-subform
    #supportsForm
    [formGroup]="form"
    [context]="this"
    (onOpen)="_defaultAllocationFormValue = form.value"
    (onCancel)="cancelManageAllocationform()"
    (onValidate)="validManageAllocationform()"
  >
    <ng-container formContent>
      <h4 class="drawer-title bold mbn mtl">
        Choisissez librement vos supports.
      </h4>
      <!-- <span class="text-secondary fs-14">Créez une allocation qui vous correspond.</span> -->
      {{ criteriaForm?.get('supportTypes')?.value }}

      <form [formGroup]="criteriaForm">
        <pr-search-input
          formControlName="autocomplete"
          [placeholder]="'Recherchez un fond'"
          class="mbm"
          (click)="resetPage()"
          variant="ASSET_SUPPORT"
        >
          <mat-select
            filterSelection
            formControlName="supportTypes"
            class="pr-button neutral filter-selection"
            placeholder="Tous"
          >
            <mat-option [value]="undefined">Tous</mat-option>
            @for (type of supportTypes; track type) {
              <mat-option [value]="type.id">
                {{ type.value }}
              </mat-option>
            }
          </mat-select>
        </pr-search-input>
      </form>

      <pr-form-select-list #formSelectList>
        @for (support of supports; track support) {
          <pr-form-select-list-option
            [tooltip]="support.name"
            [label]="support.name"
            [labelIcon]="support.favorite ? 'sp-cup' : undefined"
            [subLabel]="support.isin"
            [selected]="
              _.map(form.get('allocation').value, 'isin').includes(support.isin)
            "
            [withMoreInfoAnchor]="support.omniProductId"
            variant="ASSET_SUPPORT"
            [criterias]="[
              {
                label: 'Performance',
                value: '~',
                options: { color: 'success' },
              },
              { label: 'Niveau de risque', value: '~' },
            ]"
            (onSelect)="onSupportSelect(support)"
            (onDeselect)="onSupportDeselect(support)"
            (onMoreInfoClick)="onMoreInfoClick(support)"
          >
          </pr-form-select-list-option>
        }
      </pr-form-select-list>
      <mat-paginator
        #paginator
        [length]="supportsLength"
        [pageSize]="supportsPageSize"
        (page)="changeSupportsPage($event)"
      >
      </mat-paginator>
    </ng-container>
  </pr-subform>
</pr-form>
